import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sb-footer',
  templateUrl: './sb-footer.component.html',
  styleUrls: ['./sb-footer.component.scss'],
})
export class SbFooterComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
